const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;
const DATE_TIME = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/;

export function formatCustomFieldDateDisplay(type: string, value: string): string | null {
  const raw = value.trim();
  const kind = type.toLowerCase();

  if (kind === 'date') {
    const match = DATE_ONLY.exec(raw);
    if (!match) return null;
    const [, year, month, day] = match;
    return `${day}-${month}-${year}`;
  }

  if (kind === 'datetime') {
    const match = DATE_TIME.exec(raw);
    if (!match) return null;
    const [, year, month, day, hour, minute] = match;
    return `${day}-${month}-${year} ${hour}:${minute}`;
  }

  return null;
}
